import { createAsyncThunk } from '@reduxjs/toolkit';
import { selectVirtualBackgroundStatus } from 'features/virtual-backgrounds/selectors';
import { VirtualBackgroundFailureReason } from 'features/virtual-backgrounds/types';
import { getVirtualBackgroundFailureReason } from 'utils/webrtc/virtual-background/gateErrors';
import type { RootState } from 'store/store';

// Dynamic import to break circular dependency:
// static import of VirtualBackgroundManager → store → rootReducer → virtualBackgroundsSlice → this thunk
export const initVirtualBackground = createAsyncThunk<
  void,
  void,
  {
    state: RootState;
    rejectValue: VirtualBackgroundFailureReason | null;
  }
>(
  'virtualBackground/init',
  async (_, { rejectWithValue }) => {
    try {
      const { VirtualBackgroundManager } =
        await import('utils/webrtc/virtual-background/VirtualBackgroundManager');
      await VirtualBackgroundManager.ensureInitialized();
    } catch (error) {
      return rejectWithValue(getVirtualBackgroundFailureReason(error));
    }
  },
  {
    condition(_, { getState }) {
      const status = selectVirtualBackgroundStatus(getState());
      return status === 'idle' || status === 'error';
    },
    dispatchConditionRejection: true,
  }
);
